module.exports = __webpack_public_path__ + "img/IMG_0699.9d40a4af.jpg";